import React from "react";
import Style from "./style";

const Spinner = () => {
  return <Style>I'm a Spinner!</Style>;
};

export default Spinner;
